import { IconButton } from "@mui/material";
import { IconButtonProps } from "@mui/material/IconButton";
import { MprcMergeSx } from "components/MprcMergeSx";
import * as React from "react";

type Colors =
    MprcColors
    | "white"
    | "black"
    | "inherit"
    | "transparent";

interface IProps {
    color?: Colors;
    visible?: boolean;
    pressed?: boolean;
}

export type MprcIconButtonProps = IProps & Omit<IconButtonProps, "classes" | "color">;

export const MprcIconButton: React.FC<MprcIconButtonProps> = (props) => {

    const { className, color = "inherit", children, visible = true, sx, ...rest } = props;

    return (
        <IconButton
            {...rest}
            sx={
                MprcMergeSx(
                    sx ?? {},
                    (theme) => (
                        {
                            display: visible ? "" : "none",
                            color: color == "white" || color == "black"
                                ? theme.palette.common[color]
                                : color == "inherit"
                                    ? "inherit"
                                    : color == "transparent"
                                        ? "transparent"
                                        : theme.palette[color!].main
                        }
                    )
                )
            }
        >
            {children}
        </IconButton>
    );
};
